var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"base-edit-button",on:{"click":(e) => _vm.$emit('onButtonClicked', e)}})
}
var staticRenderFns = []

export { render, staticRenderFns }